export function isSmallMobile() {
    const threshold = 800;
    let w = screen.width;
    let h = screen.height;
    if (w > h) {
        // landscape
        if (w <= threshold) {
            return true;
        }
    }
    else {
        if (h <= threshold) {
            return true;
        }
    }
}
